import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _ from 'lodash';
import TermCard from './term-card.presentation';
import {
  setTappedTermBlNo,
  setMyPaymentTermSearchText,
  setUIError,
  downloadMyPaymentTermOrderAsync,
  showErrorSnackbar,
} from '../../redux/action';
import { CART_TAB_CIP } from '../../constant';
import LocalizedString from '../../localization';
import { isCgsItem, isShowCartTabs, unauthorizedErrorHandler } from '../../helper';

const getFilteredBl = (state, data) => _.values(data)
  .filter((item) => {
    const searchText = state.uiMyPaymentTerm.searchBarText.toLowerCase();
    return item.invoiceNo.toLowerCase().indexOf(searchText) >= 0
      || item.blNumber.toLowerCase().indexOf(searchText) >= 0
      || item.service.toLowerCase().indexOf(searchText) >= 0;
  });

const getData = (state) => {
  const { currentUser, myTermOrder, uiMyPayment } = state;
  const { selectedInnerTab } = uiMyPayment;

  const hasBothPaymentMethods = isShowCartTabs(currentUser.company);

  if (hasBothPaymentMethods) {
    const initData = Object.values(myTermOrder);
    const cipTabData = initData.filter(x => !isCgsItem(x));
    const cgsTabData = initData.filter(x => isCgsItem(x));
    const result = selectedInnerTab === CART_TAB_CIP ? cipTabData : cgsTabData;
    return getFilteredBl(state, result);
  }
  return getFilteredBl(state, myTermOrder);
};

const mapStateToProps = state => ({
  downloading: state.uiMyPaymentTerm.downloading,
  bl: getData(state),
  searchBarText: state.uiMyPaymentTerm.searchBarText,
  selectedBlNo: state.uiMyPaymentTerm.tappedBlNo,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onAppear: async () => {
    try {
      await dispatch(downloadMyPaymentTermOrderAsync());
    } catch (error) {
      dispatch(showErrorSnackbar(LocalizedString.common.alertTitleError, error.message));
      unauthorizedErrorHandler(error, ownProps.history.push);
    }
  },
  onChangeSearchBarText: (text) => {
    dispatch(setMyPaymentTermSearchText(text));
  },
  onMorePressed: (tappedBlNo) => {
    dispatch(setTappedTermBlNo(tappedBlNo));
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TermCard));
